import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
var ContextMenuContent = function ContextMenuContent(props) {
  return /*#__PURE__*/React.createElement('div', {
    className: props.getClassName('context-menu-content-wrapper'),
    'data-hook': props.dataHook
  }, props.children);
};
ContextMenuContent.displayName = displayNames.CONTEXT_MENU_CONTENT;
ContextMenuContent.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string
};
export default compose(ContextMenuContent);